import { render } from "./selectSubordinate.vue?vue&type=template&id=ed570580&scoped=true"
import script from "./selectSubordinate.vue?vue&type=script&lang=js"
export * from "./selectSubordinate.vue?vue&type=script&lang=js"

import "./selectSubordinate.vue?vue&type=style&index=0&id=ed570580&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed570580"]])

export default __exports__